import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconLayoutDashboardProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconLayoutDashboard: React.FC<IconLayoutDashboardProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Dashboard',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="7" height="9" x="3" y="3" rx="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <rect width="7" height="5" x="14" y="3" rx="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <rect width="7" height="9" x="14" y="12" rx="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <rect width="7" height="5" x="3" y="16" rx="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconLayoutDashboard;
